import { useRecoilValue } from "recoil";
import { uploadQueueState } from "../state/atoms/upload-queue";

export default function useUploadQueue() {
  const queue = useRecoilValue(uploadQueueState);
  return queue;
}
